import type { ContentObjectList, NonEventContentObjectDetail } from 'models';
import { useNavigate } from 'react-router';
import { Button, Icon } from 'ui';
import { generateContentObjectPath } from 'features/copy-to-clipboard';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
};

const ViewButton = ({ item }: P) => {
  const navigate = useNavigate();

  return (
    <Button
      icon={<Icon icon="eye-line" />}
      onClick={async () => {
        // TODO: This should not be in feature
        await navigate(generateContentObjectPath(item));
      }}
      type="text"
    >
      View
    </Button>
  );
};

export default ViewButton;
